
export class ContatoRecuperarAcesso {

  constructor(
    public cdCentrus?: number,
    public dsEmail?: string,
    public nrFone?: number,


) { }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/contato-recuperar-acesso.ts